const DISPLAY_DATE_PATTERN = /^(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d{1,2},\s+\d{4}$/i
const REVIEW_TIME_ZONE = 'America/New_York'

export const formatReviewDate = value => {
  if (!value) return ''

  // These stored review dates are already presentation values, not instants.
  // Parsing them makes Node treat them as UTC while browsers treat them as
  // local time, which shifts the day and invalidates hydration.
  const displayDate = String(value).trim()
  if (DISPLAY_DATE_PATTERN.test(displayDate)) return displayDate

  const date = new Date(value)
  if (!Number.isFinite(date.getTime())) return String(value)
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: REVIEW_TIME_ZONE,
  }).format(date)
}
